import { BoundTextAreaField, BoundTextAreaFieldProps, Only, TextFieldXss, useComputed } from "@homebound/beam";
import { ObjectState } from "src/utils/formState";
import { AiProposalValue } from "./AiProposalValue";
import { AiFieldProposalFormValue } from "./utils/aiFieldProposalForm";
import { parseAiString, pendingProposedValue, resolveAiProposalStatus } from "./utils/bindAiProposal";

// Derive proposedValue from aiProposal so callers cannot supply a conflicting value.
export type BoundAiTextAreaFieldProps<X> = Omit<BoundTextAreaFieldProps<X>, "proposedValue"> & {
  aiProposal?: ObjectState<AiFieldProposalFormValue>;
};

export function BoundAiTextAreaField<X extends Only<TextFieldXss, X>>(props: BoundAiTextAreaFieldProps<X>) {
  const { field, aiProposal, onChange, ...others } = props;
  // Track proposal status and fieldValue so the pending proposal stays in sync.
  const proposedValue = useComputed(() => pendingProposedValue(aiProposal, parseAiString), [aiProposal]);
  const originalValue = useComputed(() => field.originalValue, [field]);
  return (
    <AiProposalValue aiProposal={aiProposal} originalValue={originalValue}>
      <BoundTextAreaField
        field={field}
        proposedValue={proposedValue}
        onChange={(value) => {
          field.set(value);
          resolveAiProposalStatus(aiProposal, parseAiString, value);
          onChange?.(value);
        }}
        {...others}
      />
    </AiProposalValue>
  );
}
